import './App.css'
import axios from 'axios'
import toast from 'react-hot-toast'
import React from 'react'
// import { getUserPosition } from './helpers/locationHelper.ts'
import { Router } from './Router/Router.tsx'
import { authState, resetAuth } from './store/authState.ts'
import { controlState } from './store/controlState.ts'
import { resetData } from './store/dataState.ts'

/**
 * Detects whether an error from axios represents an authentication failure —
 * either a 401 response or a backend-reported "jwt expired" message.
 */
const isAuthFailure = (error: any): boolean => {
    if (error?.response?.status === 401) return true
    const message = error?.response?.data?.message || error?.message
    return message === 'jwt expired'
}

/**
 * Clears client-side session state. The ProtectedRoute guard will observe the
 * cleared token and redirect to the login page on next render.
 */
const handleAuthFailure = () => {
    // Avoid multiple toasts / resets if several in-flight requests fail together.
    if (!authState.token) return
    resetAuth()
    resetData()
    localStorage.removeItem('gibi')
    localStorage.removeItem('gibiUser')
    toast.error('Session expired. Please log in again.')
}

function App() {
    console.log('ver. ', import.meta.env.VITE_REACT_APP_VERSION)

    React.useEffect(() => {
        const requestId = axios.interceptors.request.use(
            (config) => {
                controlState.showLoader = true
                return config
            },
            (error) => Promise.reject(error)
        )

        const responseId = axios.interceptors.response.use(
            (response) => {
                controlState.showLoader = false
                return response
            },
            (error) => {
                controlState.showLoader = false
                // Cancellations are not errors — let them through silently.
                if (axios.isCancel(error)) return Promise.reject(error)
                // Central handling for expired / invalid auth.
                if (isAuthFailure(error)) {
                    handleAuthFailure()
                }
                return Promise.reject(error)
            }
        )

        return () => {
            axios.interceptors.request.eject(requestId)
            axios.interceptors.response.eject(responseId)
        }
    }, [])

    return <Router/>
}

export default App
